function loadGoogleMaps() {
  const script = document.createElement("script");
  const apiKey = "AIzaSyC86HIzb9WW5UDFGM7LV8mzJB9jEQgymDM";
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap&v=weekly&libraries=marker&loading=async`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

async function initMap() {
  const initial_lat = 40.73414278408156;
  const initial_lng = -4.2762470801829;
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    "marker"
  );
  // Create map
  const map = new Map(document.getElementById("map"), {
    center: { lat: initial_lat, lng: initial_lng },
    zoom: 6,
    mapId: "e122L49ZW54MnBzm",
  });
  // Create an info window to share between markers.
  const infoWindow = new InfoWindow();

  if (locationsData) {
    locationsData.forEach((location) => {
      if (location.shipsInventory) return false;
      if (location.address.latitude && location.address.longitude) {
        // Customize marker
        const backgroundColor = markerBackground ? markerBackground : "#de016b";
        const glyphColor = markerGlyphColor ? markerGlyphColor : "#ffffff";
        const borderColor = markerBorderColor ? markerBorderColor : "#de016b";
        const pinBackground = new PinElement({
          background: backgroundColor,
          glyphColor: glyphColor,
          borderColor: borderColor
        });

        // Add marker
        const marker = new AdvancedMarkerElement({
          map,
          position: {
            lat: location.address.latitude,
            lng: location.address.longitude,
          },
          content: pinBackground.element,
        });

        // Prepare HTML
        const locationHTML = buildHtml(location);

        // Add a click listener for each marker, and set up the info window.
        marker.addListener("gmp-click", () => {
          infoWindow.close();
          infoWindow.setContent(locationHTML);
          infoWindow.open(marker.map, marker);
        });
      }
    });
  }
}

function buildHtml(location) {
  let imageHtml = "";
  if (
    location.metafields &&
    location.metafields.main_image &&
    location.metafields.main_image.url
  ) {
    imageHtml = `
            <div class="sm__image-container">
               <img src="${location.metafields.main_image.url}" class="sm__img">
             </div>`;
  }

  const googleMapsText = showOnGoogleMapsText ? showOnGoogleMapsText : "Show on Google Maps";
  
  const locationHTML = `
          <div class="details">
            <div class="sm__title-container">
                <span class="sm__title">${location.name}</span>
            </div>
            ${imageHtml}
            <div>
              <ul class="sm__info">
                <li class="sm__info-item">${location.address.address1}, ${location.address.city}</li>
                <li class="sm__info-item">
                  <a href="tel:${location.address.phone}" class="sm__info-item-link">${location.address.phone}</a>
                </li>
                <li class="sm__info-item">${ location.metafields.working_hours }</li>
                <li class="sm__info-item">
                  <a 
                    href="https://maps.google.com/?q=${location.address.latitude},${location.address.longitude}"
                    class="sm__info-item-link"
                    target="_blank"
                  >
                    ${googleMapsText}
                  </a>
                </li>
              </ul>
            </div>
          </div>`;
  return locationHTML;
}

window.onload = loadGoogleMaps;
window.initMap = initMap;
